import React from 'react';
import ChangeIcon from '../../../ChangeIcon';

import GeneratePassword from '../../../../services/passwordGenerator';
import checkEmail from '../../../../services/checkEmail';
import swal from 'sweetalert';

import I18n from '../../../../locales/i18n';

const View = ({
	hide,
	icon,
	title,
	uid,
	userData = [],
	isLoading = false,
	handleShowPassword,
	showPassword = false,
	subscribersTemplate = [],
	onSave,
	onChangePhoto,
	blockName = false,
}) => {
	const _subscribersTemplate = {};
	subscribersTemplate.forEach((__subscribersTemplate) => {
		_subscribersTemplate[__subscribersTemplate.index] = {
			name: __subscribersTemplate.name,
			type: __subscribersTemplate.type,
		};
	});

	const generateCode = React.useCallback((e) => {
		e.currentTarget.parentNode.querySelector('input').value =
			GeneratePassword(4, true, 'text') + GeneratePassword(4, true, 'number');
	}, []);

	const [_name, setName] = React.useState(userData[0].value || '');

	const [needPassword, setNeedPassword] = React.useState(
		userData[1].value !== ''
	);

	return (
		<div className="subscriber-data-container">
			<div className="subscriber-data-overlay" onClick={hide}></div>
			<div className="subscriber-data-modal">
				<i className="fas fa-times close-button" onClick={hide} />
				<div className="header">
					<ChangeIcon src={icon} onChangeFile={onChangePhoto} />
					<div>
						<h1 className="title">{title}</h1>
						<h6>{uid}</h6>
					</div>
				</div>
				<form onSubmit={onSave}>
					<div className="subscriber-data">
						{userData.map((record, index) => {
							if (restrictedFields.indexOf(record.index) < 0) {
								if (record.index === 'password') {
									return (
										<FormControl title={I18n('LOGIN', 'PASSWORD')} key={index}>
											<input
												required={record.required || blockName || needPassword}
												className="form-control"
												type={showPassword ? 'text' : 'password'}
												defaultValue={record.value}
												name={record.index}
												onChange={(event) => {
													const str = event.target.value.replace(/\s/gi, '');
													event.target.value = str.trim();
												}}
											/>
											<button
												onClick={handleShowPassword}
												className="show-password btn btn-az-primary"
											>
												<i
													className={
														'fas fa-' + (showPassword ? 'eye-slash' : 'eye')
													}
												/>
											</button>
										</FormControl>
									);
								}

								if (record.index === 'code') {
									if (blockName) {
										return null;
									}
									return (
										<FormControl
											title={I18n('VIEWER_ZONE', 'ACCESS_CODE')}
											key={index}
										>
											<input
												className="form-control"
												type="text"
												defaultValue={record.value}
												name={record.index}
												onChange={(event) => {
													const str = event.target.value
														.replace(/[^a-zA-Z0-9@.ñ\-_]+/gi, '')
														.replace(/\s/gi, '');
													event.target.value = str.substr(0, 50).trim();
												}}
											/>
											<button
												onClick={generateCode}
												type="button"
												className="show-password btn btn-az-primary"
											>
												<i className="fas fa-sync" />
											</button>
										</FormControl>
									);
								}

								if (record.index === 'displayName') {
									return (
										<FormControl
											title={I18n('VIEWER_ZONE', 'FULL_NAME')}
											key={index}
										>
											<input
												className="form-control"
												type="text"
												value={_name}
												name={record.index}
												required={record.required}
												onChange={(event) => {
													const str = event.target.value.replace(
														/[^a-zA-ZñÑáéíóúÁÉÍÓÚ´`\s]+/gi,
														''
													);
													setName(str.substr(0, 50));
												}}
											/>
										</FormControl>
									);
								}

								if (record.index === 'email') {
									return (
										<FormControl title={record.label} key={index}>
											<input
												className="form-control"
												type="email"
												name={record.index}
												required={record.required}
												defaultValue={record.value}
												readOnly={blockName}
												onBlur={(event) => {
													const { value = '' } = event.target;
													if (!event.target.readOnly) {
														if (value !== '') {
															event.persist();
															setNeedPassword(true);
															if (!checkEmail(value.substr(0, 50))) {
																swal(
																	'Error',
																	I18n(
																		'VIEWER_ZONE',
																		'PLEASE_PUT_A_VALID_EMAIL'
																	),
																	'error'
																).then(() => {
																	event.target.focus();
																});
															}
														} else {
															setNeedPassword(false);
														}
													}
												}}
											/>
										</FormControl>
									);
								}

								return (
									<FormControl
										title={
											_subscribersTemplate[record.label]
												? _subscribersTemplate[record.label].name
												: requiredField[record.label] || record.label
										}
										key={index}
									>
										<input
											className="form-control"
											type={
												_subscribersTemplate[record.label]
													? _subscribersTemplate[record.label].type
													: record.type || 'text'
											}
											defaultValue={record.value}
											required={record.required}
											readOnly={blockName && record.index === 'displayName'}
											name={record.index}
										/>
									</FormControl>
								);
							}
							return null;
						})}
					</div>
					<button
						disabled={isLoading}
						type="submit"
						className="btn btn-az-primary btn-block"
						role="menuitem"
					>
						<i
							className={'fas fa-' + (isLoading ? 'spinner fa-spin' : 'save')}
						/>{' '}
						{isLoading ? I18n('COMMON', 'SAVING') : I18n('COMMON', 'SAVE')}
					</button>
				</form>
			</div>
		</div>
	);
};

export default View;

const FormControl = ({ title = '', children = null, isVisible = true }) => {
	return (
		<div
			className={isVisible ? 'row row-xs align-items-center mg-b-20' : 'hide'}
		>
			<div className="col-md-4">
				<label className="form-label mg-b-0">{title}</label>
			</div>
			<div className="col-md-8 mg-t-5 mg-md-t-0">{children}</div>
		</div>
	);
};

const restrictedFields = [
	'photoURL',
	'status',
	'time',
	'id',
	'listIndex',
	'pendingIndex',
];
const requiredField = {
	displayName: I18n('VIEWER_ZONE', 'FULL_NAME'),
};
